import React, { useState } from "react";
import CommonModal from "./CommonModal";

const RevenueEditModal = ({ isOpen, onClose, onSave, title, defaultValue }) => {
  const [value, setValue] = useState(defaultValue || "");

  return (
    <CommonModal isOpen={isOpen} onClose={onClose} elId="revenueEditModal">
      <div className="modal-header">
        <h5 className="modal-title">{title}</h5>
        <button className="btn-close" onClick={onClose}></button>
      </div>
      <div className="modal-body">
        <input
          type="text"
          className="form-control"
          value={value}
          onChange={(e) => setValue(e.target.value)}
        />
      </div>
      <div className="modal-footer">
        <button className="btn btn-secondary" onClick={onClose}>
          Close
        </button>
        <button className="btn btn-primary" onClick={() => onSave(value)}>
          Save changes
        </button>
      </div>
    </CommonModal>
  );
};

export default RevenueEditModal;
